export const isInvestDetailView = (url: string) => url.includes('detail');
